import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import {Api} from "@/shared/services/api";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {ref} from "vue";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import InsuranceCancelation from "@/shared/model/InsuranceCancelation";



export default /*@__PURE__*/_defineComponent({
  __name: 'ManagementListComponent',
  emits: ["selected"],
  setup(__props, { expose: __expose, emit: __emit }) {

const _url = Api.baseUrl + '/InsuranceCancelationGroupList';
const _adaptor = new CustomAdaptor()
const _grid = ref<InstanceType<typeof GridComponent> | null>(null)

const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}


const _dataManager = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})

const _emit = __emit

function onRowSelected(args: any) {
  _emit("selected", args.data as InsuranceCancelation)
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
}

function refresh() {
  _grid.value?.refresh()
}

__expose({
  adaptor: _adaptor, refresh
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GridComponent), {
    id: "managementList",
    ref_key: "_grid",
    ref: _grid,
    "data-source": _unref(_dataManager),
    "allow-paging": true,
    width: "auto",
    "allow-reordering": true,
    "allow-resizing": true,
    "show-column-menu": false,
    "allow-text-wrap": true,
    "row-selected": onRowSelected,
    "row-deselected": onRowDeselected,
    "page-settings": _pageSettings
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ColumnsDirective), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ColumnDirective), {
            field: "cancelationStatusDescription",
            "header-text": "status",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "personName",
            "header-text": "Kunde",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "cancelationOrderNumber",
            "header-text": "Rechnungsnummer",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "cancelationOrderedDate",
            "header-text": "Rechnungsdatum",
            "auto-fit": true,
            format: "dd.MM.yyyy",
            type: "dateTime"
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "count",
            "header-text": "Anzahl",
            "auto-fit": true
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-source"]))
}
}

})